<template>
  <div class="expert-analysis-page">
    <div
      v-if="notice"
      class="notice"
    >

      <img
        class="chromeImg"
        :src="chromeImg"
      />
      <div>
        리치고는 구글 크롬 PC 브라우저에 최적화되어 있습니다.
        <br>
        구글 크롬 PC 사용 시, 더 빠르고 쾌적한 서비스 이용이 가능합니다.
      </div>
      <v-icon
        @click="onCloseNotice"
      >mdi-close</v-icon>
    </div>
    <tableau-embedded
      v-if="tableauId !== null"
      :tableauId="tableauId"
      isCorpTableau="false"
    ></tableau-embedded>
  </div>
</template>

<script>
import TableauEmbedded from '../components/TableauEmbedded'

const CHROME_NOTICE_IGNORE_LS = "chromeNoticeIgnore"

export default {
  created() {
    this.notice = true;
    if (localStorage.getItem(CHROME_NOTICE_IGNORE_LS)) {
      this.notice = false;
    }
  },
  props: {
    tableauId: {
      type: String,
      default() { return null }
    }
  },
  data() {
    return {
      notice: true,
      chromeImg: require('../../src/assets/chrome.png'),
    }
  },
  methods: {
    onCloseNotice() {
      this.notice = false;
      localStorage.setItem(CHROME_NOTICE_IGNORE_LS, true);
    }
  },
  components: {
    TableauEmbedded
  }
}
</script>

<style scoped>
.notice {
  text-align: center;
  font-size: 14px;
  z-index:0;
}

.chromeImg {
  width: 50px;

}

</style>
